// extracted by mini-css-extract-plugin
module.exports = {"icon":"StatusIcon_icon__xrUhc","rotate":"StatusIcon_rotate__z4u20","icon--success":"StatusIcon_icon--success__4wMth","icon--error":"StatusIcon_icon--error__46h7u"};